import script from "./budget-delete-row-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./budget-delete-row-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__